import React from "react";

const StatementError = () => (
    <svg width="171" height="174" viewBox="0 0 171 174" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_119_45)">
            <path
                d="M85.5 171.711C132.72 171.711 171 133.272 171 85.8553C171 38.4387 132.72 0 85.5 0C38.2797 0 0 38.4387 0 85.8553C0 133.272 38.2797 171.711 85.5 171.711Z"
                fill="#B8AEE9"
                fillOpacity="0.13"
            />
            <path d="M137.081 41.2109H33.3408V174H137.081V41.2109Z" fill="white" />
            <path
                d="M87.7798 109.895C101.002 109.895 111.72 99.1325 111.72 85.8559C111.72 72.5792 101.002 61.8164 87.7798 61.8164C74.5581 61.8164 63.8398 72.5792 63.8398 85.8559C63.8398 99.1325 74.5581 109.895 87.7798 109.895Z"
                fill="#141516"
            />
            <path
                d="M88 102C89.1046 102 90 101.105 90 100C90 98.8954 89.1046 98 88 98C86.8954 98 86 98.8954 86 100C86 101.105 86.8954 102 88 102Z"
                fill="#E8E4F2"
            />
            <path
                d="M102.6 123.633H72.96C71.0712 123.633 69.54 125.17 69.54 127.067C69.54 128.964 71.0712 130.501 72.96 130.501H102.6C104.489 130.501 106.02 128.964 106.02 127.067C106.02 125.17 104.489 123.633 102.6 123.633Z"
                fill="#E8E4F2"
            />
            <path
                d="M86 71.3437L86 91.6563C86 92.9507 86.8952 94 88 94C89.1048 94 90 92.9507 90 91.6563L90 71.3437C90 70.0492 89.1048 69 88 69C86.8952 69 86 70.0492 86 71.3437Z"
                fill="#E8E4F2"
            />
            <path
                d="M112.86 137.367H62.7003C60.8115 137.367 59.2803 138.905 59.2803 140.801C59.2803 142.698 60.8115 144.236 62.7003 144.236H112.86C114.749 144.236 116.28 142.698 116.28 140.801C116.28 138.905 114.749 137.367 112.86 137.367Z"
                fill="#E8E4F2"
            />
        </g>
        <defs>
            <clipPath id="clip0_119_45">
                <rect width="171" height="174" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default React.memo(StatementError);
